import React from "react";
//import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";
import CurrencyFormat from './CurrencyFormat';

export default function (props) {
    const { t } = useTranslation();

    const { sliderItem, settings } = props;
    if (!sliderItem) return <div />;
    const callToAction = sliderItem.productId ?
        (<ExtendedLink className="btn btn-primary scale-up delay-1" to={`${settings.baseUrl}products/${sliderItem.productId}`}> {t("Shop Now")}  </ExtendedLink>)
        : (<a className="btn btn-primary scale-up delay-1" href={sliderItem.targetUrl} > {t("Shop Now")} </a>);

    let priceInfo = "";
    if (sliderItem.specialPrice) {
        priceInfo = <span className="text-bold"> 
            {`${t("starting from")} `}
            <CurrencyFormat value={sliderItem.specialPrice} settings={settings} /></span>;
    }
    return (
        <div className="item">
            <div className="container padding-top-3x">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-5 col-md-6 padding-bottom-2x text-md-left text-center">
                        <div className="from-bottom">
                            {/* <!--<img className="d-inline-block mb-4" src="img/hero-slider/logo03.png" style="width: 125px;" alt="Motorola">--> */}
                            <div className="h2 text-body text-normal mb-2 pt-1">
                                {sliderItem.title}
                            </div>
                            <div className="h2 text-body text-normal mb-4 pb-1">
                                {priceInfo}
                            </div>
                        </div>
                        {callToAction}
                    </div>
                    <div className="col-md-6 padding-bottom-2x mb-3">
                        <Image className="d-block mx-auto" src={sliderItem.imageUrl ? sliderItem.imageUrl : "img/no-image.jpg"}
                            fallbackSrc="img/no-image.jpg" alt={sliderItem.title} />
                        {/*<img*/}
                        {/*    className="d-block mx-auto"*/}
                        {/*    src={sliderItem.imageUrl ? sliderItem.imageUrl : "img/no-image.jpg"}*/}
                        {/*    alt={sliderItem.title}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        </div>
    );

}
